import { render, staticRenderFns } from "./retrievePwd.vue?vue&type=template&id=3102c3d0&"
import script from "./retrievePwd.vue?vue&type=script&lang=js&"
export * from "./retrievePwd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports